import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

export const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    border-radius: 0.5rem !important;
    min-width: 50rem;
    @media only screen and (max-width: 700px) {
      min-width: auto !important;
      width: calc(100% - 2rem);
      border-radius: 0.5rem !important;
    }

    @media only screen and (max-width: 480px) {
      bottom: 1rem !important;
      left: 1rem !important;
      border-radius: 0.5rem !important;
    }
  }
  .Toastify__toast-body {
    padding: 1rem;
    border-radius: 8px !important;
    font-weight: 400;
    font-size: 1.25rem;
    font-family: 'Roboto', sans-serif;
    line-height: 1.4rem;
    @media only screen and (max-width: 700px) {
      min-width: none;
      width: 100% !important;
      border-radius: 0.5rem !important;
    }
  }

  .Toastify__toast {
    border-radius: 0.5rem !important;
  }
`;
